import { render, staticRenderFns } from "./HomeUsers.vue?vue&type=template&id=010f68ac&lang=pug"
import script from "./HomeUsers.vue?vue&type=script&lang=js"
export * from "./HomeUsers.vue?vue&type=script&lang=js"
import style0 from "./HomeUsers.vue?vue&type=style&index=0&id=010f68ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports